import React from 'react';
import {ISelectProps, SelectInput} from '~/components/Controls/Select';
import {FormField, hasError, IFieldProps, onChangeField} from '~/components/Form';
import {Intent} from '~/lib/intent';
import {useResource} from '~/lib/loader';
import {ID} from '~/lib/model';
import {fetchMediation} from '~/modules/Clients/api';

type ISelectMediationProps = Omit<ISelectProps<ID>, 'items'>;

export const SelectMediation = ({
    disabled,
    ...props
}: ISelectMediationProps) => {
    const {resource, isPending} = useResource(() => fetchMediation(), []);
    return <SelectInput {...props} disabled={disabled || isPending}
        rightIcon={isPending && !disabled && <i className='fa fa-spinner fa-spin'/>}
        items={resource}/>;
};

export const SelectMediationField = (props: IFieldProps<ISelectMediationProps>) => <FormField {...props}>
    <SelectMediation {...props.options}
        intent={hasError(props) && Intent.DANGER}
        value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;
